import { useContext } from 'react';

import AuthContext from './AuthContext';

const useAuth = (throwOnMissingContext = true) => {
  const context = useContext(AuthContext);
  if (context === null) {
    if (throwOnMissingContext) {
      throw new Error('useAuth must be used within an AuthProvider');
    }
    return {};
  }
  return context;
};

export default useAuth;
